import {WechatInitOptions, OpenCheckInDataType} from "../../base/options";
import * as rp from "request-promise";
import {WechatService} from "../wechatservice";
import {TokenService} from "../../token/tokenservice";
import {ApprovalTokenService} from "../../token/approvaltokenservice";

/**
 * 企业微信 审批 服务
 */
export class ApprovalService {

  /*
   * 获取审批数据
   * */
  static async getApprovalData(startTime: number, endTime: number, nextSpnum?: number): Promise<any> {
    let wechatOptions: WechatInitOptions = await WechatService.getWechatOptions();
    let tokenService: TokenService = new ApprovalTokenService();
    let accessToken: string = await tokenService.getAccessToken();
    let param: any = {
      method: "POST",
      uri: `${wechatOptions.corp.apiUrl}corp/getapprovaldata?access_token=${accessToken}`,
      body: {
        "starttime": startTime,
        "endtime": endTime
      },
      json: true
    };

    if (nextSpnum) {
      param.body.next_spnum = nextSpnum;
    }

    let result: any = await rp(param);

    if (!result.errcode) {
      delete result.errcode;
      delete result.errmsg;

      return result;
    } else {
      console.error(`get approval data failed , response:`);
      console.error(result);
    }

    return "";
  }

}
